/** Traductions bannière mode sécurisé stockage (FR / AR) */
export const storageSafeModeBannerFr = {
  label: 'Mode sécurisé stockage : données de base en lecture seule — ventes autorisées',
  dismissDev: 'Désactiver (dev)'
};

export const storageSafeModeBannerAr = {
  label: 'وضع الأمان: البيانات الرئيسية للقراءة فقط — البيع مسموح',
  dismissDev: 'إيقاف (تطوير)'
};

/** Écart inventaire — mode sécurisé stock (ADR-0016) */
export const inventoryLedgerSafeModeFr = {
  label:
    'Écart de stock détecté — mode sécurisé (stock en lecture seule)',
  rescan: 'Revérifier',
  scanning: 'Analyse…',
  dismissDev: 'Désactiver (dev)'
};

export const inventoryLedgerSafeModeAr = {
  label: 'انحراف في دفتر المخزون — وضع الأمان (المخزون للقراءة فقط)',
  rescan: 'إعادة الفحص',
  scanning: 'جاري الفحص…',
  dismissDev: 'إيقاف (تطوير)'
};
